import React, { FC } from "react";

import { Modal } from "antd";
import { inject, observer } from "mobx-react";
import ReactMarkdown from "react-markdown";

interface Props {
  controller?: any;
}

const EventInfoModal: FC<Props> = inject("controller")(
  observer((props) => {
    const event = props.controller.selectedEvent;

    return (
      <Modal
        title={event?.name}
        open={props.controller.showInfoModal}
        footer={null}
        width="90vw"
        style={{ maxWidth: 900 }}
        onCancel={() => (props.controller.showInfoModal = false)}
      >
        <div className="markdown-body text-justify">
          {event?.info ? (
            <ReactMarkdown>{event.info}</ReactMarkdown>
          ) : (
            <p>More information about this event will be available soon.</p>
          )}
        </div>
      </Modal>
    );
  })
);

export default EventInfoModal;
